import {
  PieceAnnotation,
  TrackingNumberAnnouncementStatus,
  TrackingNumberValidationStatus,
  Workflow,
} from '@apiContract';
import { getBarcodesStatusesCounts } from 'src/utils/annotations';

enum Alert {
  NoTracking = 'No tracking numbers were identified',
  Identified = 'Tracking number(s) identified successfully',
  NotUnique = 'This item does not have any unique tracking numbers',
  AllDuplicate = 'All tracking numbers match another active item. This item may be a duplicate.',

  LockersIdentified = 'Tracking number(s) identified and sent to lockers successfully',
  UnableTracking = 'Some tracking numbers were unable to be sent to lockers',

  Duplicate = 'This item looks like it was already received. Please delete it or its duplicate',
  MustBeAssigned = 'Item must be assigned to send tracking number(s) to lockers',
}

enum Severity {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}

const tooltips = {
  barcode: 'Reading barcodes.',
  lockers: 'Sending to lockers.',
};

export const getGlobalAlert = (annotations: Array<PieceAnnotation> | null) => {
  if (!annotations) return;

  const statuses = getBarcodesStatusesCounts(annotations);

  if (!statuses.all) {
    return { text: Alert.NoTracking, severity: Severity.Warning };
  }

  if (statuses[TrackingNumberValidationStatus.Valid]) {
    return { text: Alert.Identified, severity: Severity.Success };
  }

  if (statuses[TrackingNumberValidationStatus.Conflict]) {
    return { text: Alert.AllDuplicate, severity: Severity.Error };
  }

  if (statuses[TrackingNumberValidationStatus.BadFormat]) {
    return { text: Alert.NotUnique, severity: Severity.Warning };
  }
};

export const getTooltip = (workflow: Workflow, annotation?: PieceAnnotation, hasRecipient?: boolean) => {
  if (!annotation) {
    return tooltips.barcode;
  }
  if (workflow === Workflow.Lockers) {
    const announcementStatus = annotation.pieceAnnotationsTrackingNumber?.announcementStatus;
    const validationStatus = annotation.pieceAnnotationsTrackingNumber?.validationStatus;

    if (
      hasRecipient &&
      validationStatus === TrackingNumberValidationStatus.Valid &&
      (announcementStatus === TrackingNumberAnnouncementStatus.None ||
        announcementStatus === TrackingNumberAnnouncementStatus.Sent)
    ) {
      return tooltips.lockers;
    }
    return null;
  }
};
